/* ==========================================================================
   HUMO BARRILES · PRODUCTOS ESPEJO DE LA OFERTA
   assets/humo-upsell-espejos.js

   El carrito no debe mostrar al cliente el nombre con el sufijo del
   espejo. Aquí se limpia en la columna 3 del configurador.
   ========================================================================== */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-preorder-root]');
  if (!raiz) return;

  var SUFIJO = /\s*\(Flash offer\)\s*$/i;

  function limpiar() {
    var titulos = raiz.querySelectorAll('.hb-pre__linea-titulo');
    for (var i = 0; i < titulos.length; i++) {
      var t = titulos[i];
      if (SUFIJO.test(t.textContent)) {
        t.textContent = t.textContent.replace(SUFIJO, '');
        if (!t.querySelector('.hb-pre__chapa-flash')) {
          var ch = document.createElement('span');
          ch.className = 'hb-pre__chapa-flash';
          ch.textContent = 'FLASH 40%';
          t.appendChild(ch);
        }
      }
    }
  }

  var cuerpo = raiz.querySelector('[data-preorder-items]');
  if (cuerpo) {
    new MutationObserver(limpiar).observe(cuerpo, { childList: true, subtree: true });
  }
  limpiar();
})();
